<template>
  <q-dialog
    :model-value="modal.show"
    @update:model-value="onDialogModelUpdate"
    :persistent="!!modal.data?.persistent"
    @escape-key="() => closePopup(modal.type, true)"
    :allow-focus-outside="false"
    :full-width="!!modal.data?.wide || !!modal.data?.extraWide"
    :class="['modal__dialog', { modal__dialog_m19: modal.type === MODAL_NAMES.M19Overuse }]"
  >
    <q-card
      :class="[
      'modal__wrapper',
      'scrollbar__wrapper',
      { modal__wrapper_borderless: !!modal.data?.borderless },
      { modal__wrapper_wide: !!modal.data?.wide && !modal.data?.extraWide },
      { modal__wrapper_extra_wide: !!modal.data?.extraWide },
      { modal__wrapper_m19: modal.type === MODAL_NAMES.M19Overuse },
      { 'modal__wrapper_narrow': modal.type === 'AddPresetKit' }
    ]"
      ref="componentRef"
    >
      <q-card-section
        class="row items-center q-pb-none justify-between modal__header no-wrap"
      >
        <div class="row items-center min-w-0 col modal__header-title">
          <span class="text-h6 modal__title shrink-0">{{ modal.data?.title || '' }}</span>
          <span
            v-if="m19ModalProjectTypeLabel"
            class="modal__m19-project-type-chip"
            :title="m19ModalProjectTypeLabel"
          >{{ m19ModalProjectTypeLabel }}</span>
        </div>
        <q-btn
          :class="['close-btn', 'shrink-0', { 'text-red': !!modal.data?.borderless }]"
          @click="() => closePopup(modal.type)"
          flat
          dense
          round
          v-close-popup
        >
          <img src="/img/icons/close.svg" style="width: 13px;" alt="close" />
        </q-btn>
      </q-card-section>

      <div class="modal__content">
        <component
          v-if="CurrentModalComponent"
          :is="CurrentModalComponent"
          :data="modal.data"
          :closeModal="closePopup"
        />
      </div>
    </q-card>
  </q-dialog>

  <q-dialog
    v-model="showDiscardConfirm"
    persistent
    class="modal__discard-dialog"
  >
    <q-card class="modal__discard-card">
      <q-card-section class="modal__discard-header row items-center no-wrap q-pb-sm">
        <div class="modal__discard-icon" aria-hidden="true">
          <q-icon name="warning_amber" color="amber-9" size="28px" />
        </div>
        <div class="col modal__discard-text">
          <div class="text-h6 modal__discard-title">
            Закрыть окно?
          </div>
          <div class="text-body2 text-grey-8 modal__discard-msg">
            {{ discardMessage }}
          </div>
        </div>
      </q-card-section>
      <q-card-actions align="right" class="modal__discard-actions">
        <CustomButton outlined :height="36" style="padding: 0 20px;" @click="cancelDiscardClose">
          Вернуться
        </CustomButton>
        <CustomButton color="negative" style="padding: 0 20px;" :height="36" @click="confirmDiscardClose">
          Закрыть без сохранения
        </CustomButton>
      </q-card-actions>
    </q-card>
  </q-dialog>

  <SecondaryModal />
</template>

<script setup>
import { computed, ref, provide } from 'vue'
import { storeToRefs } from 'pinia'
import CustomButton from '@/components/common/CustomButton.vue'
import SecondaryModal from './SecondaryModal.vue'
import ConfirmModal from '@/components/modal/modals/modal-types/ConfirmModal'
import ModalText from '@/components/modal/modals/modal-text'
import ModalGallery from '@/components/modal/modals/modal-gallery'
import FloorSchemaObjectInfo from '@/components/modal/modals/floor-schema-object-info'
import AddMaterialRequest from '@/components/modal/modals/add-material-request'
import AddMaterialRequestBulk from '@/components/modal/modals/add-material-request-bulk'
import EditMaterialRequestQty from '@/components/modal/modals/edit-material-request-qty'
import AddMaterial from '@/components/modal/modals/add-material'
import AddProviderEntry from '@/components/modal/modals/add-provider-entry'
import UploadProviderNcaKey from '@/components/modal/modals/upload-provider-nca-key'
import GroupEditUnits from '@/components/modal/modals/group-edit-units'
import ChangeEntranceDocument from '@/components/modal/modals/change-entrance-document'
import SchemaPointInfo from '@/components/modal/modals/schema-point-info'
import ProjectDocumentSigners from '@/components/modal/modals/project-document-signers'
import CheckGroupHistory from '@/components/modal/modals/check-group-history'
import AddOpenSpaceLink from '@/components/modal/modals/add-open-space-link'
import AddPackageEntry from '@/components/modal/modals/add-package-entry'
import AddProjectEntry from '@/components/modal/modals/add-project-entry'
import UpdWriteoffInfo from '@/components/modal/modals/upd-writeoff-info'
import AddResidentEntry from '@/components/modal/modals/add-resident-entry'
import UpdPackageEntry from '@/components/modal/modals/upd-package-entry'
import UpdProjectExecutor from '@/components/modal/modals/upd-project-executor'
import ProjectMaterialsSmeta from '@/components/modal/modals/project-materials-smeta'
import AddFloorMap from "@/components/modal/modals/add-floor-map";
import AddProjectFloor from "@/components/modal/modals/add-project-floor";
import ResidentialGrouping from "@/components/modal/modals/residential-grouping";
import UpdSet from '@/components/modal/modals/upd-set'
import AddMaterialProviderPrice from '@/components/modal/modals/add-material-provider-price'
import CopyPasteEntranceProperties from '@/components/modal/modals/copy-paste-entrance-properties'
import ProviderRequestsMaterialSelect from '@/components/modal/modals/provider-requests-material-select'
import ChangeProjectMaterials from '@/components/modal/modals/change-project-materials'
import FloorMapErrors from "@/components/modal/modals/floor-map-errors";
import FrameTypeParams from "@/components/modal/modals/frame-type-params";
import UpdFrameTypeParam from "@/components/modal/modals/frame-type-params/UpdParam";
import FrameUpd from "@/components/modal/modals/frame-upd";
import AddDocumentEntry from '@/components/modal/modals/add-document-entry'
import Add_HANDBOOK_CONTRACTOR from '@/components/modal/modals/add-handbook-contractor'
import Add_HANDBOOK_PROVIDER from '@/components/modal/modals/add-handbook-provider'
import AddRevitData from '@/components/modal/modals/add-revit-data'
import AddConstructive from '@/components/modal/modals/add-constructive'
import AddConstructivePrice from '@/components/modal/modals/add-constructive-price'
import EditConstructiveSet from '@/components/modal/modals/edit-constructive-set'
import CreateConstructiveGroupSet from '@/components/modal/modals/create-constructive-group-set'
import EditWorkSetGroup from '@/components/modal/modals/edit-work-set-group'
import AddBlock from '@/components/modal/modals/add-block'
import AddTierGroupWork from '@/components/modal/modals/add-tier-group-work'
import { useAppStore } from '@/services/store/app'
import { MODAL_NAMES } from '@/constants'
import EditTierPlan from '@/components/modal/modals/edit-tier-plan'
import EditTierFact from '@/components/modal/modals/edit-tier-fact'
import AddAttorney from '@/components/modal/modals/add-attorney'
import EditTierFactTimeline from '@/components/modal/modals/edit-tier-fact-timeline'
import EditLaborFact from '@/components/modal/modals/edit-labor-fact'
import AddParamLink from '@/components/modal/modals/add-param-link'
import RecalcProjectMaterialPrices from '@/components/modal/modals/recalc-project-material-prices'
import EditTaskParams from '@/components/modal/modals/edit-task-params'
import ViewWorkGroupTasks from '@/components/modal/modals/view-work-group-tasks'
import AddWorkGroupLevel from '@/components/modal/modals/add-work-group-level'
import EditWorkGroupLevel from '@/components/modal/modals/edit-work-group-level'
import AddWorkGroupDict from '@/components/modal/modals/add-work-group-dict'
import AddTaskDict from '@/components/modal/modals/add-task-dict'
import AddReason from '@/components/modal/modals/add-reason'
import AddProjectLimit from '@/components/modal/modals/add-project-limit'
import AddMaterialCertificate from '@/components/modal/modals/add-material-certificate'
import AddLaboratoryAct from '@/components/modal/modals/add-laboratory-act'
import AddMobileAppVersion from "@/components/modal/modals/add-mobile-app-version";
import ProviderInvoiceInfo from '@/components/modal/modals/provider-invoice-info'
import ProviderRealizationInfo from '@/components/modal/modals/provider-realization-info'
import SelectProjectGrouped from '@/components/modal/modals/select-project-grouped'
import CreateInvoice from '@/components/modal/modals/create-invoice'
import UploadInvoice from '@/components/modal/modals/upload-invoice'
import ViewInvoice from '@/components/modal/modals/view-invoice'
import ViewRealize from '@/components/modal/modals/view-realize'
import SelectMaterial from '@/components/modal/modals/select-material'
import SupplierRequestAddMaterial from '@/components/modal/modals/supplier-request-add-material'
import AddFloorFlatParamValue from '@/components/modal/modals/add-floor-flat-param-value'
import ChangeProjectDate from '@/components/modal/modals/change-project-date'
import AddPresetKit from '@/components/modal/modals/add-preset-kit'
import EditProjectTypeWarranty from '@/components/modal/modals/edit-project-type-warranty'
import SelectWarranty from '@/components/modal/modals/select-warranty'
import EditAvrSetting from '@/components/modal/modals/edit-avr-setting'
import ManualAvrCalls from '@/components/modal/modals/manual-avr-calls'
import M19Overuse from '@/components/modal/modals/m19-overuse'
import AddMaterialLimit from '@/components/modal/modals/add-material-limit'
import EditMaterialLimit from '@/components/modal/modals/edit-material-limit'
import AddProjectMaterialLimit from '@/components/modal/modals/add-project-material-limit'
import EditProjectMaterialLimit from '@/components/modal/modals/edit-project-material-limit'
import AddProjectGeodesist from '@/components/modal/modals/add-project-geodesist'
import AddWorkSetCheckGroupSchema from '@/components/modal/modals/add-work-set-check-group-schema'
import SelectDate from '@/components/modal/modals/select-date'
import ExecListCreateDocument from '@/components/modal/modals/exec-list-create-document'
import ExecListCreatePickCall from '@/components/modal/modals/exec-list-create-pick-call'
import AsrHiddenWorksPreCall from '@/components/modal/modals/asr-hidden-works-pre-call'
import AsrCreatePickCall from '@/components/modal/modals/asr-create-pick-call'
import AsrCreateOrReform from '@/components/modal/modals/asr-create-or-reform'
import PreNuCallSteps from '@/components/modal/modals/pre-nu-call-steps'
import DuplicateProjectPerformers from '@/components/modal/modals/duplicate-project-performers'
import SmetaRecalcSuccess from '@/components/modal/modals/smeta-recalc-success'
import MobileAppPromo from '@/components/modal/modals/mobile-app-promo'
import DuplicateBpmnSchema from '@/components/modal/modals/duplicate-bpmn-schema'
import ProrabK2svTaskConfirm from '@/components/modal/modals/prorab-k2sv-task-confirm'

const appStore = useAppStore()
const { modal } = storeToRefs(appStore)

const showDiscardConfirm = ref(false)

const DEFAULT_DISCARD_MESSAGE =
  'Введённые данные не будут сохранены и будут утеряны.'

const discardMessage = computed(() => {
  const msg = modal.value?.data?.confirmUnsavedCloseMessage
  return typeof msg === 'string' && msg.trim() ? msg.trim() : DEFAULT_DISCARD_MESSAGE
})

/** Тип проекта в шапке модалки M19 (рядом с заголовком). */
const m19ModalProjectTypeLabel = computed(() => {
  if (modal.value?.type !== MODAL_NAMES.M19Overuse) return ''
  const d = modal.value?.data || {}
  const s =
    (d.project_type_name && String(d.project_type_name).trim()) ||
    (d.params?.project_type_name && String(d.params.project_type_name).trim()) ||
    (d.filters?.project_type_name && String(d.filters.project_type_name).trim()) ||
    ''
  return s
})

/**
 * Предупреждение о потере данных: передайте в data при открытии модалки confirmUnsavedClose: true.
 * Свой текст: confirmUnsavedCloseMessage. Отключить для служебных окон: skipCloseConfirm: true.
 */
function shouldConfirmDiscardClose() {
  if (modal.value?.type === 'ConfirmModal') return false
  if (modal.value?.data?.skipCloseConfirm) return false
  return modal.value?.data?.confirmUnsavedClose !== false
}

function performModalClose({ runOnClose = true } = {}) {
  const onClose = modal.value?.data?.onClose
  showDiscardConfirm.value = false
  appStore.closeModal()
  if (runOnClose && onClose) onClose()
}

function requestDiscardClose() {
  if (!shouldConfirmDiscardClose()) {
    performModalClose({ runOnClose: false })
    return
  }
  showDiscardConfirm.value = true
}

function cancelDiscardClose() {
  showDiscardConfirm.value = false
}

function confirmDiscardClose() {
  performModalClose({ runOnClose: true })
}

provide('requestModalDiscardClose', requestDiscardClose)

const modalComponents = {
  ConfirmModal,
  'modal-text': ModalText,
  'modal-gallery': ModalGallery,
  FloorSchemaObjectInfo,
  AddMaterialRequest,
  AddMaterialRequestBulk,
  EditMaterialRequestQty,
  AddMaterial,
  AddProviderEntry,
  UploadProviderNcaKey,
  GroupEditUnits,
  ChangeEntranceDocument,
  SchemaPointInfo,
  ProjectDocumentSigners,
  checkGroupHistory: CheckGroupHistory,
  addOpenSpaceLink: AddOpenSpaceLink,
  AddPackageEntry,
  AddProjectEntry,
  UpdWriteoffInfo,
  AddResidentEntry,
  UpdPackageEntry,
  UpdProjectExecutor,
  UpdSet,
  AddMaterialProviderPrice,
  ProjectMaterialsSmeta,
  CopyPasteEntranceProperties,
  ProviderRequestsMaterialSelect,
  ChangeProjectMaterials,
  AddFloorMap,
  AddProjectFloor,
  ResidentialGrouping,
  FloorMapErrors,
  FrameTypeParams,
  FrameUpd,
  UpdFrameTypeParam,
  AddDocumentEntry,
  Add_HANDBOOK_CONTRACTOR,
  Add_HANDBOOK_PROVIDER,
  AddRevitData,
  AddConstructive,
  AddConstructivePrice,
  EditConstructiveSet,
  CreateConstructiveGroupSet,
  EditWorkSetGroup,
  AddBlock,
  AddTierGroupWork,
  EditTierPlan,
  EditTierFact,
  AddAttorney,
  EditTierFactTimeline,
  EditLaborFact,
  AddParamLink,
  RecalcProjectMaterialPrices,
  EditTaskParams,
  ViewWorkGroupTasks,
  AddWorkGroupLevel,
  EditWorkGroupLevel,
  AddWorkGroupDict,
  EditWorkGroupDict: AddWorkGroupDict,
  AddTaskDict,
  EditTaskDict: AddTaskDict,
  AddReason,
  EditReason: AddReason,
  AddProjectLimit: AddProjectLimit,
  AddMaterialCertificate,
  AddLaboratoryAct,
  AddMobileAppVersion,
  ProviderInvoiceInfo,
  ProviderRealizationInfo,
  SelectProjectGrouped,
  CreateInvoice,
  UploadInvoice,
  ViewInvoice,
  ViewRealize,
  SelectMaterial,
  SupplierRequestAddMaterial,
  AddFloorFlatParamValue,
  ChangeProjectDate,
  AddPresetKit,
  Edit_Project_Type_Warranty: EditProjectTypeWarranty,
  Select_Warranty: SelectWarranty,
  Edit_Avr_Setting: EditAvrSetting,
  ManualAvrCalls,
  M19Overuse,
  AddMaterialLimit,
  EditMaterialLimit,
  AddProjectMaterialLimit,
  EditProjectMaterialLimit,
  AddProjectGeodesist,
  AddWorkSetCheckGroupSchema,
  SelectDate,
  ExecListCreateDocument,
  ExecListCreatePickCall,
  AsrHiddenWorksPreCall,
  AsrCreatePickCall,
  AsrCreateOrReform,
  PreNuCallSteps,
  DuplicateProjectPerformers,
  SmetaRecalcSuccess,
  MobileAppPromo,
  DuplicateBpmnSchema,
  ProrabK2svTaskConfirm,
}

const CurrentModalComponent = computed(() => {
  return modalComponents[modal.value.type] || null
})

function closePopup(type, isConfirm = false) {
  const currentType = modal.value.type
  if(isConfirm) {
    if (type !== currentType && type !== undefined) return

    if (shouldConfirmDiscardClose()) {
      requestDiscardClose()
      return
    }
    performModalClose()
    return
  }
  const onClose = modal.value?.data?.onClose

  if(type === currentType || type === undefined) {
    appStore.closeModal()
  }
  if(onClose) onClose()
}

function onDialogModelUpdate(value) {
  if (value === true) {
    appStore.$patch((s) => {
      if (s.modal) s.modal = { ...s.modal, show: true }
    })
    return
  }
  if (modal.value?.data?.close === false) return
  if (!shouldConfirmDiscardClose()) {
    performModalClose({ runOnClose: true })
    return
  }
  requestDiscardClose()
}
</script>

<style scoped lang="scss">
.modal {
  &__wrapper {
    padding: 15px;
    padding-bottom: 20px;
    border-radius: 8px;
    max-width: initial !important;
    width: auto;

    &_borderless {
      background: none;
      box-shadow: none;
      max-height: initial !important;
    }

    &_wide {
      width: 90vw;
      max-width: 1000px !important;

      @media (max-width: 576px) {
        width: 95vw;
      }
    }

    &_narrow {
      max-width: 500px !important;
      width: 90vw;
      
      @media (max-width: 576px) {
        width: 95vw;
      }
    }
  }

  &__header {
    gap: 10px;
    flex-wrap: nowrap;
    padding: 0;
    padding-bottom: 10px;
  }

  &__title {
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
  }

  &__header-title {
    flex: 1 1 auto;
    min-width: 0;
    align-items: baseline;
    gap: 0;
  }

  @media (max-width: 576px) {
    &__wrapper {
      padding: 15px;
    }

    &__dialog {
      padding: 15px;
    }
  }

  @media (max-width: 370px) {
    &__wrapper {
      padding: 10px;
    }

    &__dialog {
      padding: 5px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
  }
}

/* Вид типа проекта в шапке «Создать M19», как на макете: нейтральный «pill» */
.modal__m19-project-type-chip {
  flex-shrink: 1;
  min-width: 0;
  margin-left: 12px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  color: #455a64;
  background-color: #eceff1;
  border-radius: 9999px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: min(560px, 54vw);

  @media (max-width: 576px) {
    margin-left: 8px;
    max-width: 42vw;
  }
}

/* q-card в этом компоненте; без родителя .modal селекторы выше могут не цепляться */
/*
  Quasar по умолчанию даёт q-dialog__inner--minimized > div max-width: 560px на sm+.
  :full-width на q-dialog снимает это. Здесь фиксируем размер карточки с первого кадра,
  чтобы не было «узко при открытии и шире после загрузки/ресайза».
*/
/* То же семейство классов без предка `.modal` (см. коммент выше про nested .modal &__wrapper). */
:deep(.modal__wrapper_wide:not(.modal__wrapper_m19)) {
  box-sizing: border-box;
  width: calc(100vw - 12px) !important;
  max-width: calc(100vw - 12px) !important;
  min-width: 0;
}

:deep(.modal__wrapper_extra_wide:not(.modal__wrapper_m19)) {
  box-sizing: border-box;
  width: calc(100vw - 12px) !important;
  min-width: 0 !important;
  max-width: calc(100vw - 12px) !important;
  min-height: min(520px, calc(100vh - 48px));
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .modal__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}


:deep(.modal__dialog.modal__dialog_m19) {
  --m19-modal-cap: 2000px;
}

:deep(.modal__dialog_m19 .q-dialog__inner) {
  padding: 24px 40px !important;
  width: 100%;
  max-width: 100vw !important;
  justify-content: center;
  align-items: center;
}

:deep(.modal__wrapper.modal__wrapper_m19) {
  box-sizing: border-box;
  border-radius: 12px !important;
  width: min(var(--m19-modal-cap, 2000px), calc(100vw - 80px)) !important;
  max-width: min(var(--m19-modal-cap, 2000px), calc(100vw - 80px)) !important;
  margin-left: auto !important;
  margin-right: auto !important;
  flex-shrink: 0;
  max-height: min(72vh, calc(100vh - 120px)) !important;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  box-shadow:
    0 8px 32px rgba(15, 23, 42, 0.07),
    0 1px 3px rgba(15, 23, 42, 0.04);

  &.modal__wrapper {
    padding: 12px 10px 0;
    padding-bottom: 0;
  }

  /* Побеждаем общий .modal__wrapper_wide (100vw): те же ограничения высоты, ширину не трогаем — задаёт блок выше */
  &.modal__wrapper_wide,
  &.modal__wrapper_extra_wide {
    margin-left: auto !important;
    margin-right: auto !important;
    max-height: min(72vh, calc(100vh - 120px)) !important;
    min-height: 0 !important;
  }

  .modal__header {
    padding-bottom: 14px !important;
    border-bottom: 1px solid #eceff2;
    flex-shrink: 0;
  }

  .modal__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.modal__discard-card {
  min-width: 320px;
  max-width: 420px;
  border-radius: 12px;
}

.modal__discard-header {
  gap: 14px;
  padding: 20px 20px 8px;
}

.modal__discard-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(245, 158, 11, 0.14);
}

.modal__discard-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
}

.modal__discard-msg {
  margin-top: 6px;
  line-height: 1.45;
}

.modal__discard-actions {
  gap: 5px;
  padding: 8px 16px 16px;

  :deep(.customBtn) {
    width: auto;
    min-width: 120px;
  }
}
</style>

<style lang="scss">
/* Quasar при full-width: `.q-dialog__inner--fullwidth > div { width/max-width: 100% !important }`
   попадает на сам `<q-card>` (div). Объект `:style` без !important не перебивает это;
   без scoped переменная/селектор гарантированно применится к teleport. */
.modal__dialog_m19.q-dialog .q-dialog__inner.q-dialog__inner--fullwidth > div.q-card.modal__wrapper.modal__wrapper_m19 {
  --m19-modal-cap: 2000px;
  box-sizing: border-box;
  width: min(var(--m19-modal-cap), calc(100vw - 80px)) !important;
  max-width: min(var(--m19-modal-cap), calc(100vw - 80px)) !important;
  margin-left: auto !important;
  margin-right: auto !important;
  flex-shrink: 0;
}
</style>
